import { useContext } from "@nuxtjs/composition-api";

export function useMiniMarketActions() {
  const { $mutate, $query, i18n } = useContext();

  async function saveMiniMarket(submitData) {
    try {
      if (submitData.id !== null) {
        const UPDATE_MINI_MARKET = await import("./updateMiniMarket.graphql");
        return await $mutate(UPDATE_MINI_MARKET, submitData, {
          showErrorToast: true,
          showSuccessToast: true,
          successMessage: i18n.t("conductor.messages.updateSuccess", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
          errorMessage: i18n.t("conductor.messages.updateError", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
        });
      } else {
        const CREATE_MINI_MARKET = await import("./createMiniMarket.graphql");
        return await $mutate(CREATE_MINI_MARKET, submitData, {
          showErrorToast: true,
          showSuccessToast: true,
          successMessage: i18n.t("conductor.messages.createSuccess", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
          errorMessage: i18n.t("conductor.messages.createError", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
        });
      }
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function deleteMiniMarketById(id) {
    try {
      const DELETE_MINI_MARKET = await import("./deleteMiniMarketById.graphql");
      await $mutate(
        DELETE_MINI_MARKET,
        { id },
        {
          showErrorToast: true,
          showSuccessToast: true,
          successMessage: i18n.t("conductor.messages.deleteSuccess", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
          errorMessage: i18n.t("conductor.messages.deleteError", {
            entity: i18n.t("conductor.miniMarkets.singular"),
          }),
        }
      );
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getMiniMarketById(id) {
    try {
      const GET_MINI_MARKET = await import("./getMiniMarketById.graphql");
      const { miniMarketById } = await $query(GET_MINI_MARKET, { id });
      return miniMarketById;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  async function getMiniMarkets(params) {
    try {
      const GET_MINI_MARKETS = await import("./miniMarketsDataTable.graphql");
      const { miniMarketsDataTable } = await $query(GET_MINI_MARKETS, params);
      return miniMarketsDataTable;
    } catch (e) {
      console.error(e);
      return Promise.reject(e);
    }
  }

  return {
    saveMiniMarket,
    deleteMiniMarketById,
    getMiniMarketById,
    getMiniMarkets,
  };
}
